import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyLifeActsMenuComponent } from './myLifeActsMenu.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { LifeActsMenuItemComponent } from './lifeActMenuItem/lifeActsMenuItem.component';
import { IsMenuItemSelectedPipe } from './isMenuItemSelected.pipe';

@NgModule({
  declarations: [MyLifeActsMenuComponent, IsMenuItemSelectedPipe],
  exports: [MyLifeActsMenuComponent],
  imports: [CommonModule, MatExpansionModule, LifeActsMenuItemComponent],
  providers: [IsMenuItemSelectedPipe],
})
export class MyLifeActsMenuModule {}
